import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';

import _ from 'lodash';
import TableList from '@/components/TableList/index.vue';
import { getPlayableReport } from '@/api/dashboard/report';
import adsTerms from '@/views/dashboard/ads-terms';
import { format } from 'date-fns';
import Pagination from '@com/components/pagination/index.vue';

export default {
  components: {
    TableList: TableList, Pagination: Pagination
  },
  data: function data() {
    return {
      query: {
        page: 1,
        page_size: 15
      },
      pagination: {
        total: 1
      },
      dateRange: '',
      columnConfig: [{
        label: '日期',
        prop: 'date'
      }, {
        label: 'impression',
        prop: 'impression',
        dataFormat: {
          type: 'number', // string，可选 number/text/percentage/currency/permillage
          thousandsSeparator: true // boolean，是否要千位分隔符
        }
      }, {
        label: 'click',
        prop: 'click',
        dataFormat: {
          type: 'number', // string，可选 number/text/percentage/currency/permillage
          thousandsSeparator: true // boolean，是否要千位分隔符
        }
      }, {
        label: 'install',
        prop: 'install',
        dataFormat: {
          type: 'number', // string，可选 number/text/percentage/currency/permillage
          thousandsSeparator: true // boolean，是否要千位分隔符
        }
      }, {
        label: 'revenue',
        prop: 'revenue',
        dataFormat: {
          type: 'currency', // string，可选 number/text/percentage/currency/permillage
          thousandsSeparator: true, // boolean，是否要千位分隔符
          currencyType: 'USD',
          decimals: 2
        }
      }, {
        renderHeader: this.renderHeader,
        label: 'CTR',
        prop: 'ctr',
        dataFormat: {
          type: 'percentage',
          decimals: 2
        }
      }, {
        renderHeader: this.renderHeader,
        label: 'CVR',
        prop: 'cvr',
        dataFormat: {
          type: 'percentage',
          decimals: 2
        }
      }, {
        renderHeader: this.renderHeader,
        label: 'IVR',
        prop: 'ivr',
        dataFormat: {
          type: 'percentage',
          decimals: 2
        }
      }],
      list: [],
      loading: true,
      period: 'day',
      periods: [{
        label: '按天',
        value: 'day'
      }, {
        label: '按周',
        value: 'week'
      }, {
        label: '按月',
        value: 'month'
      }],
      traffic_type: '',
      traffic_types: [{
        label: 'MSDK',
        value: 'msdk'
      }, {
        label: 'DSP',
        value: 'dsp'
      }, {
        label: 'MSDK + DSP',
        value: ''
      }]
    };
  },
  mounted: function mounted() {
    this.dateRange = [Date.now() - 31 * 86400 * 1000, Date.now() - 86400 * 1000];
    this.search();
  },

  methods: {
    initData: function initData(params) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var res, list;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.loading = true;
                _this.list = [];
                _context.next = 4;
                return getPlayableReport(params);

              case 4:
                res = _context.sent;
                list = _.get(res, 'data.data.list') || [];

                _this.pagination.total = _.get(res, 'data.data.total');
                list.forEach(function (item) {
                  item.date = format(item.start, 'YYYY-MM-DD') + (item.end ? ' ~ ' + format(item.end, 'YYYY-MM-DD') : '');
                  item.ctr = adsTerms.ctr.compute(item.click, item.impression);
                  item.cvr = adsTerms.cvr.compute(item.click, item.install);
                  item.ivr = adsTerms.ivr.compute(item.install, item.impression);
                  item.revenue = item.revenue / 1000;
                });
                _this.list = list;
                _this.loading = false;

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    search: function search() {
      this.initData({
        sdate: format(this.dateRange[0], 'YYYYMMDD'),
        edate: format(this.dateRange[1], 'YYYYMMDD'),
        period: this.period,
        page: this.query.page,
        page_size: this.query.page_size,
        traffic_type: this.traffic_type,
        get_total: 1
      });
    },
    renderHeader: function renderHeader(h, _ref) {
      var column = _ref.column,
          $index = _ref.$index;

      return h(
        'el-popover',
        {
          attrs: {
            placement: 'top-start',
            title: adsTerms[column.property].fullName,
            width: '200',
            trigger: 'hover'
          }
        },
        [adsTerms[column.property].formula, h(
          'span',
          { slot: 'reference' },
          [adsTerms[column.property].name]
        )]
      );
    },
    handleCurrentChange: function handleCurrentChange(page) {
      this.query.page = page;
      this.search();
    },
    handleSizeChange: function handleSizeChange(size) {
      this.query.page_size = size;
      this.search();
    }
  }
};